import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetBlockedShippingCompanyForCustomerList = () =>
    request({
        url: ApiURL.Query.GetBlockedShippingCompanyForCustomerList,
        method: RequestType.GET,
    });
const GetRejectedReturnList = (params: any) =>
    request({
        url: ApiURL.Query.GetRejectedReturnList,
        method: RequestType.GET,
        params: params,
    });
const GetDigitalCardTemplates = () =>
    request({
        url: ApiURL.Query.GetDigitalCardTemplates,
        method: RequestType.GET,
    });

const GetWalletTransactionByCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetWalletTransactionByCustomerId,
        method: RequestType.GET,
        params: params,
    });
const GetShippingCompanies = (params?: any) =>
    request({
        url: ApiURL.Query.GetShippingCompanies,
        method: RequestType.GET,
        params: params,
    });
const GetFiscal = (params?: any) =>
    request({
        url: ApiURL.Query.GetFiscal,
        method: RequestType.GET,
        params: params,
    });
const GetFiscalType = (params?: any) =>
    request({
        url: ApiURL.Query.GetFiscalType,
        method: RequestType.GET,
        params: params,
    });
const GetFiscalList = (params?: any) =>
    request({
        url: ApiURL.Query.GetFiscalList,
        method: RequestType.GET,
        params: params,
    });

const GetFinanceReport = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetFinanceReport,
        method: RequestType.POST,
        data,
    });

const PostCheckoutQuery = {
    GetRejectedReturnList,
    GetBlockedShippingCompanyForCustomerList,
    GetDigitalCardTemplates,
    GetWalletTransactionByCustomerId,
    GetShippingCompanies,
    GetFiscal,
    GetFiscalType,
    GetFiscalList,
    GetFinanceReport,
};

export default PostCheckoutQuery;
